<template>

            <div class="titulo">
                <div class="margem container">
                    <div class="m-icone direita"></div>
                    <div class="m-icone direita">
                        <div class="pesquisa">
                            <input type="text" placeholder="Pesquisar Rotina" />
                            <a disabled class="icone-pesquisa"></a>
                        </div>
                    </div>
                    <h2>Rotina</h2>
                </div>
            </div>
            <div class="margem container">
                <div class="submit">
                    <v-btn @click="abrirModalNovo" icon="mdi mdi-plus"></v-btn>
                </div>
                <br>

                <div class="bloco margem">
                    <table class="tabela" v-if="!loading">
                        <tbody style="cursor: pointer;">
                            <tr>
                                <th>Grupos de Discussão</th>
                                <th>Participantes</th>
                                <th></th>
                            </tr>
                            <tr v-for="item in grupos" :key="item.id" @click="visualizarGrupo(item)">
                                <td>{{ item.nome }}</td>
                                <td>
                                    {{item.participantes.length > 0 ? item.participantes.map(p =>
                                        nomeEsobrenome(p.nome ?? p.nomeCompleto)).join(', ') : '-'}}
                                </td>
                                <td>
                                    <div>
                                        <v-menu>
                                            <template v-slot:activator="{ props }">
                                                <v-btn
                                                    style="width: 2rem; height: 2rem; border: 1px solid var(--cor-separador); color: var(--cor-fonte);"
                                                    class="botaoAdicionarSprint acao-secundaria"
                                                    icon="mdi-dots-horizontal" v-bind="props">
                                                </v-btn>
                                            </template>

                                            <v-list>
                                                <v-list-item @click="editarGrupo(item)">
                                                    Editar
                                                </v-list-item>
                                                <v-list-item style="color: red;" @click="removerGrupo(item.id)">
                                                    Excluir
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-else class="loading">
                        <div></div>
                    </div>
                </div>
            </div>
            <ModalAdicionarGrupo
                :mostrar="mostrarModal"
                :usuarios="pessoas"
                :id-usuario="idUsuario"
                :grupo-para-editar="grupoParaEditar"
                @fechar="cancelar"
                @criar="onCriarGrupo"
                @salvar-edicao="onSalvarEdicao"
            />

</template>
<script>
import { dataParaInput } from "@/utils/date";
import ModalAdicionarGrupo from "@/components/Modais/rotina/ModalAdicionarGrupo.vue";
import serviceRotina from "@/services/serviceRotina";
import { consultarSetores } from "@/services/usuario-setor";
import serviceFunções from "@/services/serviceFunções";
import { sso } from "roboflex-thalamus-sso-lib";

export default {
    name: "GruposView",

    components: { ModalAdicionarGrupo },

    data() {
        return {
            loading: true,
            grupos: [],
            pessoas: [],
            grupoParaEditar: null,
            mostrarModal: false,
            idUsuario: null,
        };
    },

    created() {
        const usuarioLogado = sso.getUsuarioLogado();
        this.idUsuario = usuarioLogado.id;
    },

    async mounted() {
        const { usuarios } = await consultarSetores();
        this.pessoas = usuarios || [];
        this.buscarGrupos();
    },

    methods: {
        nomeEsobrenome(nome) {
            return serviceFunções.nomeEsobrenome(nome);
        },
        abrirModalNovo() {
            this.grupoParaEditar = null;
            this.mostrarModal = true;
        },
        cancelar() {
            this.mostrarModal = false;
            this.grupoParaEditar = null;
        },
        editarGrupo(item) {
            this.grupoParaEditar = { ...item };
            this.mostrarModal = true;
        },
        async buscarGrupos() {
            this.grupos = await serviceRotina.getGrupos();
            this.loading = false;
        },
        async onCriarGrupo(payload) {
            const fullPayload = {
                tipo_id: 6,
                nome: payload.nome,
                responsavel_id: this.idUsuario,
                dtInicio: dataParaInput(new Date().toISOString()),
                dtFimPrevisto: payload.dtFimPrevisto || null,
                participantes: payload.participantes,
            };
            const response = await serviceRotina.criarGrupo(fullPayload);
            if (response) {
                this.cancelar();
                this.buscarGrupos();
            }
        },
        async onSalvarEdicao(payload) {
            const response = await serviceRotina.editarGrupo(payload.id, {
                nome: payload.nome,
                participantes: payload.participantes,
            });
            if (response) {
                this.cancelar();
                this.buscarGrupos();
            }
        },
        visualizarGrupo(item) {
            this.$router.push({ name: "grupoView", params: { id: item.id } });
        },
        removerGrupo(id) {
            this.grupos = this.grupos.filter((g) => g.id !== id);
            serviceRotina.deletarGrupo(id);
        },
    },
};
</script>
<style scoped>
.participantes {
    max-height: 20rem !important;
    overflow: auto;
}
</style>